import { MonthlyHistoryModel } from '../models/monthly-history';

/**
 * Adapter para converter dados da API de média histórica mensal
 */
export class MonthlyHistoryAdapter {
  /**
   * Converte os dados da API para o modelo MonthlyHistoryModel
   * @param data Dados retornados pela API
   * @returns Objeto MonthlyHistoryModel
   */
  static fromApi(data: any): MonthlyHistoryModel {
    return {
      stationId: data.stationId,
      month: data.month,
      averageTemperature: data.averageTemperature,
      averageRainAccum: data.averageRainAccum,
    };
  }
}
